var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCallGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_48638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2834 3.33317C10.9345 3.46021 11.533 3.77868 12.0021 4.24779C12.4712 4.71691 12.7897 5.31535 12.9167 5.9665M10.2834 0.666504C11.6362 0.816795 12.8978 1.42262 13.8609 2.38451C14.824 3.3464 15.4314 4.60718 15.5834 5.95984M14.9167 11.2798V13.2798C14.9175 13.4655 14.8794 13.6493 14.805 13.8194C14.7307 13.9895 14.6216 14.1422 14.4848 14.2677C14.3479 14.3933 14.1864 14.4888 14.0105 14.5483C13.8347 14.6078 13.6483 14.6299 13.4634 14.6132C11.4119 14.3903 9.44137 13.6893 7.71004 12.5665C6.09926 11.5429 4.73359 10.1773 3.71004 8.5665C2.58336 6.82731 1.8822 4.84717 1.66337 2.7865C1.64671 2.60215 1.66862 2.41634 1.7277 2.24092C1.78679 2.0655 1.88175 1.9043 2.00655 1.76758C2.13134 1.63087 2.28324 1.52164 2.45256 1.44685C2.62189 1.37206 2.80493 1.33334 2.99004 1.33317H4.99004C5.31357 1.32999 5.62723 1.44456 5.87254 1.65553C6.11786 1.8665 6.27809 2.15947 6.32337 2.47984C6.40779 3.11988 6.56434 3.74832 6.79004 4.35317C6.87973 4.59179 6.89915 4.85111 6.84597 5.10042C6.7928 5.34973 6.66928 5.57858 6.49004 5.75984L5.64337 6.6065C6.59241 8.27553 7.97434 9.65747 9.64337 10.6065L10.49 9.75984C10.6713 9.5806 10.9001 9.45707 11.1494 9.4039C11.3988 9.35073 11.6581 9.37014 11.8967 9.45984C12.5016 9.68554 13.13 9.84209 13.77 9.9265C14.0939 9.97219 14.3896 10.1353 14.6011 10.3848C14.8125 10.6344 14.9248 10.9529 14.9167 11.2798Z",
    stroke: "#48B16E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_48638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallGreen);
export default __webpack_public_path__ + "static/media/icon_call_green.33e05ac358538e78d38b358e46608327.svg";
export { ForwardRef as ReactComponent };